import React from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { sanitizeMarkdownSource } from '../../utils/sanitizeMarkdown';

interface SafeMarkdownProps {
  children: string;
  remarkPlugins?: React.ComponentProps<typeof ReactMarkdown>['remarkPlugins'];
  rehypePlugins?: React.ComponentProps<typeof ReactMarkdown>['rehypePlugins'];
  components?: Components;
}

/**
 * Markdown renderer without rehype-raw; sanitizes source before parse.
 */
const SafeMarkdown: React.FC<SafeMarkdownProps> = ({
  children,
  remarkPlugins = [remarkGfm],
  rehypePlugins,
  components,
}) => {
  const safe = sanitizeMarkdownSource(children);
  return (
    <ReactMarkdown
      remarkPlugins={remarkPlugins}
      rehypePlugins={rehypePlugins}
      components={components}
    >
      {safe}
    </ReactMarkdown>
  );
};

export default SafeMarkdown;
